// extracted by mini-css-extract-plugin
module.exports = {"atom__item-availability-container":"styles_atom__item-availability-container__a75Mr","item-availability-title":"styles_item-availability-title__hS3nI"};